<template>
  <div>
    <tk-flex middle between  wrap class="p-b-20">
      <publicHeader showBack :title="storeDetail.fullName"></publicHeader>
      <tk-flex wrap :gutter="12">
        <a-button @click="deleteStore" v-if="can('deleteStoreModel') && storeDetail.status === 'pass'">
          删除
        </a-button>
        <a-button type="primary" @click="showStoreEdit = true" v-if="can('editStoreModel') && storeDetail.status === 'pass'">
          编辑
        </a-button>
        <a-button type="primary" @click="showStoreAudit = true" v-if="can('auditStoreModel') && storeDetail.status === 'review'">
          审核
        </a-button>
      </tk-flex>
    </tk-flex>
    <div style="background:#fff">
      <a-spin :spinning="spinning">
        <Layout
          :showMenu="true" :menuList="menuList" :defaultKeys="defaultKeys"
          :activeKey.sync="key"
          :mainImage="true"
          :mainImageUrl="storeDetail.storePhoto && storeDetail.storePhoto.length ? storeDetail.storePhoto[0] : ''"
        >
          <template slot="content">
            <div class="full-width full-height" style="color:#363B45" v-if="key === 0">
              <!-- 基本信息 -->
              <div class="font-14 p-b-24" style="font-weight: 700;">基本信息</div>
              <a-row class="full-width" :gutter="[24,24]">
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店序号：</div>
                    <div style="flex-grow: 1">{{storeDetail.number}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">所属代理：</div>
                    <div style="flex-grow: 1">{{storeDetail.agent ? storeDetail.agent.fullName: ''}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">所属地区：</div>
                    <div style="flex-grow: 1">{{$tkRegions.getFullName(storeDetail.region)}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">上门服务：</div>
                    <div style="flex-grow: 1">{{storeDetail.isCome ? '支持' : '不支持'}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">服务范围：</div>
                    <div style="flex-grow: 1">{{storeDetail.serviceScope}}km</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店等级：</div>
                    <div style="flex-grow: 1">{{storeDetail.storeLevel ? storeDetail.storeLevel.name: ''}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店星级：</div>
                    <div style="flex-grow: 1">{{storeDetail.storeStarRating ? storeDetail.storeStarRating.name: ''}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">业务员：</div>
                    <div style="flex-grow: 1">{{storeDetail.salesman ? storeDetail.salesman.nickName : ''}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">关联用户：</div>
                    <div style="flex-grow: 1">{{storeDetail.user ? storeDetail.user.nickName : ''}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">联系电话：</div>
                    <div style="flex-grow: 1">{{storeDetail.phone}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店积分：</div>
                    <div style="flex-grow: 1">{{storeDetail.points}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">店铺地址：</div>
                    <div style="flex-grow: 1">{{storeDetail.address}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店图片：</div>
                    <ak-type-input v-model="storeDetail.storePhoto" :field="storePhotoOptions"  hideLabel />
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="storeDetail.qrcodePoster">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店二维码：</div>
                    <ak-type-input v-if="storeDetail.qrcodePoster" v-model="storeDetail.qrcodePoster" :field="qrcodePosterOptions"  hideLabel />
                    <ak-type-input v-else v-model="storeDetail.QRcode" :field="QRcodeOptions"  hideLabel />
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店位置：</div>
                    <ak-type-input v-model="storeDetail.location" :field="locationOptions" hideLabel/>
                  </tk-flex>
                </a-col>
              </a-row>
            </div>
            <div class="full-width full-height" style="color:#363B45" v-if="key === 1 && can('inventoryStoreModel') && storeDetail.status === 'pass'">
              <tk-flex between middle style="paddingBottom: 18px;">
                <div style="color:#363B45;font-weight: 700;font-size: 14px;">门店铺货</div>
                <div class="createStock">
                  <a-button @click="syncProducts">
                    同步商品
                  </a-button>
                </div>
                <!-- <div class="createStock">
                  <a-button @click="showCreateStock = true">
                    新增商品
                  </a-button>
                </div> -->
              </tk-flex>
              <ak-model-table style="width:100%" model="distributionStock" ref="distributionStock" :filters="{store: id, isDelete: {$ne: true}}" :perPage="20" tableSize="small" />
            </div>
            <div class="h-full" v-if="(key === 2 && can('inventoryStoreModel') || key === 1 && !can('inventoryStoreModel')) && storeDetail.status === 'pass'">
              <div style="color:#363B45;font-weight: 700;font-size: 14px;">积分变动</div>
              <div style="color:#363B45;font-weight: 400;font-size: 12px;" class="p-y-12">当前积分 {{storeDetail.points}}</div>
              <ak-model-table style="width:100%" model="pointsDetails" ref="pointsDetails"  :perPage="20" :filters="{store: id}" tableSize="small"/>
            </div>
          </template>
        </Layout>
      </a-spin>
    </div>
    <createStore v-if="showStoreEdit" :tag="'edit'" :record="storeDetail" @refresh="refreshStoreDetail" @complete="showStoreEdit = false"></createStore>
    <createDistributionStock v-if="showCreateStock" :store="id" :agent="storeDetail.agent.objectId" @complete="() => { showCreateStock = false }" @refresh="()=>{ refreshStock() }"></createDistributionStock>
    <auditCreateStore v-if="showStoreAudit" :record="storeDetail" @refresh="refreshStoreDetail" @complete="showStoreAudit = false"></auditCreateStore>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'
import Layout from '../components/layout.vue'
import createStore from './component/createStore.vue'
import createDistributionStock from './component/createDistributionStock.vue'
import auditCreateStore from './component/auditCreateStore'
export default {
  components: {
    publicHeader,
    Layout,
    createStore,
    createDistributionStock,
    auditCreateStore
  },
  data () {
    return {
      id: '',
      storeDetail: {},
      key: 0, // 当前选中的key
      defaultKeys: [],
      menuList: [],
      showStoreEdit: false,
      storePhotoOptions: {
        name: 'storePhoto',
        note: '门店图片',
        type: 'Array',
        disabled: true,
        items: {
          type: 'Image'
        },
        validators: [
          (val) => val ? null : '不能为空'
        ]
      },
      locationOptions: {
        name: 'location',
        note: '店铺位置',
        type: 'GeoPoint',
        disabled: true,
        validators: [
          (val) => val ? null : '不能为空'
        ]
      },
      QRcodeOptions: {
        name: 'QRcode',
        note: '门店二维码',
        type: 'Image',
        disabled: true
      },
      qrcodePosterOptions: {
        name: 'qrcodePoster',
        note: '门店二维码',
        type: 'Image',
        disabled: true
      },
      spinning: true,
      showCreateStock: false,
      showStoreAudit: false
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.key = this.$route.query.index ? Number(this.$route.query.index) : 0
    if (!this.defaultKeys.length) {
      this.defaultKeys.push(Number(this.key))
    }
    this.init()
  },
  methods: {
    async init () {
      try {
        let { data: res } = await this.$tkParse.get(`/classes/store/${this.id}`, {
          params: {
            include: 'user,salesman,agent,storeLevel,storeStarRating'
          }
        })
        this.storeDetail = res
        if (this.can('inventoryStoreModel')) {
          this.menuList = [
            {
              name: '基本信息'
            },
            {
              name: '门店铺货'
            },
            {
              name: '积分变动'
            }
          ]
        } else {
          this.menuList = [
            {
              name: '基本信息'
            },
            {
              name: '积分变动'
            }
          ]
        }
        if (this.storeDetail.status !== 'pass') {
          this.menuList = [{ name: '基本信息' }]
        }
        this.spinning = false
      } catch (e) {}
    },
    async refreshStoreDetail () {
      this.spinning = true
      this.showStoreEdit = false
      this.showStoreAudit = false
      await this.init()
    },
    refreshStock () {
      this.$refs.distributionStock.refresh()
    },
    deleteStore () {
      try {
        this.$confirm({
          title: '提示',
          content: '确定要删除该门店吗？删除门店后，库存会自动清零，请谨慎操作！',
          onOk: async () => {
            // 获取订单
            let { data: order } = await this.$tkParse.get(`/classes/order`, {
              params: {
                where: {
                  $or: [
                    {
                      status: {
                        $in: ['0', '1']
                      }
                    },
                    {
                      status: '3',
                      refundStatus: '0'
                    }
                  ],
                  store: this.id
                }
              }
            })
            if (order.results.length) {
              this.$notification['error']({
                message: '操作失败',
                description: '该门店下存在未处理订单，无法删除'
              })
              return
            }
            let { data: returnData } = await this.$tkParse.post(`/store/deleteStore`, {
              id: this.id
            })
            if (returnData.code !== 'success') {
              this.$notification['error']({
                message: '网络错误',
                description: '删除失败，请稍后重试'
              })
            } else {
              this.$notification['success']({
                message: '操作成功',
                description: '删除成功'
              })
              this.$router.replace('/store')
            }
          }
        })
      } catch (e) {
        console.log(e)
        this.$notification['error']({
          message: '网络错误',
          description: '操作失败'
        })
      }
    },
    // 同步商品
    async syncProducts () {
      try {
        this.spinning = true
        let { data: res } = await this.$tkParse.post('/store/syncProduct', {
          storeId: this.id
        })
        if (res.code !== 'success') {
          throw new Error(res.msg)
        }
        this.spinning = false
        this.$notification['success']({
          message: '操作成功',
          description: '同步成功'
        })
        this.refreshStock()
      } catch (e) {
        this.spinning = false
        this.$notification['error']({
          message: '网络错误',
          description: '同步失败'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .ant-form-item {
    flex-grow: 1;
    margin-bottom: 0;
    padding-bottom: 0;
    .ant-form-item-control-wrapper{
      width: 100%;
    }
    .ant-form-item-label{
      padding-top: 4px;
    }
  }
  .array-img-input-wrap{
    .ignore-item {
      display: none;
    }
  }
}
.createStock{
  ::v-deep{
    .ant-btn{
      color: #FF2A58;
      border-radius: 6px;
      border: 1px solid #FF2A58;
    }
  }
}
</style>
